import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {INSTRUCTIONS_SEARCH_QUERY_KEY, INSTRUCTIONS_TENANT_ID} from '../../consts'
import {prepareInstructionFormData} from '../../mappers'
import {DocumentUpdate, Instruction} from '../../types/documents.types'

type Params = {
  plantId: string
  options?: UseMutationOptions<Instruction, AxiosError, DocumentUpdate>
}

export const useDocumentCreate = ({plantId, options}: Params) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (event: DocumentUpdate) => {
      const formData = prepareInstructionFormData(event)
      const response = await ApiClient.axiosInstance.post<DocumentUpdate>(
        `/instructions/${INSTRUCTIONS_TENANT_ID}/plants/${plantId}/instructions`,
        formData
      )
      return response.data
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({queryKey: [INSTRUCTIONS_SEARCH_QUERY_KEY]})
      await options?.onSuccess?.(...args)
    }
  })
}
